import React, {useEffect, useState} from 'react';
import {Link, useHistory} from "react-router-dom";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {Button, Modal} from "antd";
import axios from "axios";
import {API_PATH} from "../../components/const";
import {toast} from "react-toastify";
import Collapse from "@mui/material/Collapse";


const AdminServices = () => {
    let history = useHistory()
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [data, setData] = useState([])
    const [deleteId, setDeleteId] = useState(null);
    const [selCol, setSelCol] = useState([]);
    const [sendData, setSendData] = useState({});
    const [type, setType] = useState(1)
    const [loader, setLoader] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [selectParent, setSelectParent] = useState({})
    const showModalDelete = (id, actionType) => {
        setIsModalOpen(true);
        setDeleteId(id)
        setType(actionType)
    };
    const handleCancelDelete = () => {
        setIsModalOpen(false);
    };
    const handleOkDelete = () => {
        // axios.delete(API_PATH + "company/delete/" + deleteId, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
        //     .then(res =>{
        //         setIsModalOpen(false);
        //         setDeleteId(null)
        //         getData()
        //     })
        //     .catch(err =>{
        //         toast(err =>{
        //             toast.error("Failed")
        //         })
        //     })
        if (selectParent?.id > 0) {
            axios.delete(API_PATH + "service/part/delete/" + deleteId, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    setIsModalOpen(false);
                    setDeleteId(null)
                    getData()
                })
                .catch(err => {
                    toast(err => {
                        toast.error("Failed")
                    })
                })
        }
    };
    const saveService = () => {
        if (selectParent?.id > 0) {
            axios.post(API_PATH + "service/part/create", {
                ...sendData,
                service_id: selectParent?.id
            }, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    getData()
                    setOpenModal(false)
                    toast.success("Успешно добавлено")
                })
        } else {
            axios.post(API_PATH + "service/create", sendData, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    getData()
                    setOpenModal(false)
                    toast.success("Успешно добавлено")
                })
        }


    }

    const editService = () => {
        if (selectParent?.id > 0) {
            // console.log(selectParent)
            axios.put(API_PATH + "service/part/update/" + selectParent?.id, {
                name: sendData?.name,
                description: sendData?.description,
                service_id: sendData?.service_id
            }, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    getData()
                    setOpenModal(false)
                    toast.success("Успешное редактирование")
                })
        } else {
            axios.put(API_PATH + "service/update/" + sendData?.id, {
                name: sendData?.name,
                title: sendData?.title
            }, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    getData()
                    setOpenModal(false)
                    toast.success("Успешное редактирование")
                })

        }
    }
    const getItem = (id) => {
        axios.get(API_PATH + "service/" + id, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setSendData(res?.data)
                setOpenModal(true)
            })
    }
    const getItemPart = (id) => {
        setDeleteId(id)
        axios.get(API_PATH + "service/part/" + id, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setSendData(res?.data)
                setOpenModal(true)
            })
    }
    const getData = () => {
        axios.get(API_PATH + "service/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setData(res?.data)
            })
    }
    const removeItem = (id) => {

        if (selCol.indexOf(id) < 0) {

            setSelCol([...selCol, id])
        } else {
            setSelCol(selCol?.filter(item => item != id))
        }
    }

    useEffect(() => {
        getData()
    }, [isModalOpen]);
    return (
        <div className="profile-edit users">
            <div className="progress-link">
                <Link to="/global-admin/services"> <img src="/icon/Icon1.svg" alt="."/></Link>
                <img src="/icon/arrowleft.svg" alt="."/>
                <Link to="/global-admin/services"> <span>Услуги</span></Link>
            </div>
            <div className="employees-header ">
                <div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="left-head">
                            <h6 className="font-family-medium">Услуги</h6>
                            {/*<button onClick={importFc}>123123123</button>*/}
                        </div>
                        <div className="right-head">
                            <button className="add-btn font-family-medium"
                                    onClick={() => {
                                        setOpenModal(true)
                                        setType("save")
                                    }}><img
                                src="/icon/plus.svg"/> Добавить новое
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="emp-table">
                <TableContainer component={Paper}>
                    <Table sx={{minWidth: 650}} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell className="table-head">Название</TableCell>
                                <TableCell className="table-head" align="right">Под названием</TableCell>
                                <TableCell className="table-head" align="right">Действие</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.map((item, index) => (
                                <>
                                    <TableRow
                                        key={item.name}
                                        className="cursor-pointer"
                                        onClick={() => removeItem(index)}
                                        sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                    >
                                        <TableCell component="th" scope="row">

                                            <span className="t-name font-family-medium">{item?.name}</span>
                                        </TableCell>
                                        <TableCell component="th" align="right" scope="row">
                                            <span className="t-name font-family-medium">{item?.title}</span>
                                        </TableCell>
                                        <TableCell className="twt" align="right">
                                            <div className="con-btns-all">
                                                <div className="con-btns-all">
                                                    <button className="t-delete-btn font-family-medium"
                                                            onClick={() => showModalDelete(item?.id)}>Удалить
                                                    </button>
                                                    <button className="t-edit-btn font-family-medium"
                                                            onClick={() => {
                                                                getItem(item?.id)
                                                                setSelectParent({})
                                                                setOpenModal(true)
                                                            }}>
                                                        Изменить
                                                    </button>
                                                </div>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
                                            <Collapse in={selCol?.filter(item2 => item2 === index)?.length > 0}
                                                      timeout="auto" unmountOnExit>
                                                <div>
                                                    <button className="add-btn font-family-medium mt-3 mb-3"
                                                            onClick={() => {
                                                                setOpenModal(true)
                                                                setSelectParent(item)
                                                                setType("save")
                                                            }}>
                                                        <img
                                                            src="/icon/plus.svg"
                                                            alt="+"
                                                        /> Добавить новое
                                                    </button>
                                                </div>
                                                {
                                                    item?.service_parts?.map(item3 => (
                                                        <p className="text-white d-flex justify-content-between mt-2 mb-2">
                                                            <div>
                                                                {item3?.name}
                                                            </div>
                                                            <div className="con-btns-all">
                                                                <div className="con-btns-all">
                                                                    <button className="t-delete-btn font-family-medium"
                                                                            onClick={() => {
                                                                                showModalDelete(item3?.id)
                                                                                setSelectParent(item3)
                                                                            }}>Удалить
                                                                    </button>

                                                                    <button className="t-edit-btn font-family-medium"
                                                                            onClick={() => {
                                                                                getItemPart(item3?.id)
                                                                                setSelectParent(item3)
                                                                                setOpenModal(true)
                                                                            }}>
                                                                        Изменить
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </p>
                                                    ))
                                                }
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>
                                </>
                            ))}

                        </TableBody>
                    </Table>
                </TableContainer>

            </div>
            <Modal title="Внимание!"
                   open={isModalOpen}
                   onCancel={handleCancelDelete}
                   footer={[<Button key="submit" type="default" onClick={handleCancelDelete}>
                       Отменить
                   </Button>, <Button key="submit" type="danger" className="my-red-canc" onClick={handleOkDelete}>
                       Да, удалить
                   </Button>]}
            >
                <p className="pt-2 pb-2 text-white">Вы уверены, что удалите этого филиаля? Это невозможно отменить</p>
            </Modal>
            <Modal title="Внимание!"
                   open={openModal}
                   onCancel={() => setOpenModal(false)}
                   footer={[<Button key="submit" type="default" onClick={() => setOpenModal(false)}>
                       Отменить
                   </Button>,
                       type === "save" ?
                           <Button key="submit" type="primary" className="my-red-canc" onClick={saveService}>
                               Сохранять
                           </Button>
                           : <Button key="submit" type="primary" className="my-red-canc" onClick={editService}>
                               Редактировать
                           </Button>

                   ]

                   }
            >
                <div className="cam-add-modal">
                    {
                        selectParent?.id > 0 ?
                            <>
                                <div className="inputs-box">
                                    <label className="font-family-medium">{selectParent?.name}</label>

                                </div>
                                <div className="inputs-box">
                                    <label className="font-family-medium">Название</label>
                                    <input
                                        value={sendData?.name}
                                        onChange={(e) => setSendData({...sendData, name: e.target.value})}
                                        type="text"/>
                                </div>
                                <div className="inputs-box mt-3">
                                    <label className="font-family-medium">Под названием</label>
                                    <input
                                        value={sendData?.description}
                                        onChange={(e) => setSendData({...sendData, description: e.target.value})}
                                        type="text"/>
                                </div>
                            </>
                            :
                            <>

                                <div className="inputs-box">
                                    <label className="font-family-medium">Название</label>
                                    <input
                                        value={sendData?.name}
                                        onChange={(e) => setSendData({...sendData, name: e.target.value})}
                                        type="text"/>
                                </div>
                                <div className="inputs-box mt-3">
                                    <label className="font-family-medium">Под названием</label>
                                    <input
                                        value={sendData?.title}
                                        onChange={(e) => setSendData({...sendData, title: e.target.value})}
                                        type="text"/>
                                </div>
                            </>
                    }
                    {/*<div className="inputs-box">*/}
                    {/*    <label className="font-family-medium">Название</label>*/}
                    {/*    <input*/}
                    {/*        value={sendData?.name}*/}
                    {/*        onChange={(e) => setSendData({...sendData, name: e.target.value})}*/}
                    {/*        type="text"/>*/}
                    {/*</div>*/}
                    {/*<div className="inputs-box mt-3">*/}
                    {/*    <label className="font-family-medium">Под названием</label>*/}
                    {/*    <input*/}
                    {/*        value={sendData?.title}*/}
                    {/*        onChange={(e) => setSendData({...sendData, title: e.target.value})}*/}
                    {/*        type="text"/>*/}
                    {/*</div>*/}
                </div>
            </Modal>
        </div>
    );
};

export default AdminServices;